import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { EContentService } from "../../../globals/services/enhancedContent.service";
import ListFilter from "../components/ListFilter";
import ListTabel from "../components/ListTabel";
import { PAGE_SIZE } from "../constants";

export const VolumeList = ({ navigateToVolumePage, updateVolumeCount, currentPage, setCurrentPage }) => {
    const { me } = useSelector((state) => state.auth);
    const eContentService = EContentService();
    
    const [volumes, setVolumes] = useState([]);
    const [nameFilter, setNameFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [filteredVolumes, setFilteredVolumes] = useState([]);
    const [prevFilters, setPrevFilters] = useState({ name: "", status: "All" });

    const applyFilters = useCallback(() => {
        return volumes.filter(volume => {
            const matchesName = nameFilter ? volume.title.toLowerCase().includes(nameFilter.toLowerCase()) : true;
            const matchesStatus = statusFilter === "All" || volume.status === statusFilter;
            return matchesName && matchesStatus;
        });
    }, [volumes, nameFilter, statusFilter]);

    useEffect(() => {
        const filtered = applyFilters();
        setFilteredVolumes(filtered);
        updateVolumeCount(filtered.length);
        
        if (nameFilter !== prevFilters.name || statusFilter !== prevFilters.status) {
            setCurrentPage(1);
            setPrevFilters({ name: nameFilter, status: statusFilter });
        }
    }, [volumes, nameFilter, statusFilter, applyFilters, updateVolumeCount, setCurrentPage, prevFilters]);
    
    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * PAGE_SIZE;
        const endIndex = startIndex + PAGE_SIZE;
        return filteredVolumes.slice(startIndex, endIndex);
    };

    const loadVolumeList = useCallback(async () => {
        if (me) {
            try {
                const response = await eContentService.getVolumeList();
                setVolumes(response.data);
            } catch (error) {
                console.error("Error fetching volume list:", error);
            }
        }
    }, [me]);

    useEffect(() => {
        loadVolumeList();
    }, [loadVolumeList]);

    const clearFilters = () => {
        setNameFilter("");
        setStatusFilter("All");
    };

    const handleDeleteVolume = async (volumeId) => {
        await eContentService.deleteVolume(volumeId);
        loadVolumeList();
    }

    const handleUpdateVolumeStatus = async (volumeId, status) => {
        const updatedVolume = filteredVolumes.find(volume => volume._id === volumeId);
        if (!updatedVolume) {
            console.error("Volume not found");
            return;
        }

        try {
            await eContentService.updateVolume({
                ...updatedVolume,
                status,
                modifiedBy: me ? me._id : null,
                modified: moment().format('YYYY-MM-DD')
            });
            await loadVolumeList();
        } catch (error) {
            console.error("Error updating volume status:", error);
        }
    }

    const columns = [
        { key: "title", label: "Title" },
        { key: "status", label: "Status" }
    ];

    return (
        <>
            <ListFilter
                filterByName={setNameFilter}
                filterByStatus={setStatusFilter}
                nameFilter={nameFilter}
                statusFilter={statusFilter}
                clearFilters={clearFilters}
            />
            <div style={{paddingBottom: "20px"}}>
                <ListTabel
                    itemName="volumes"
                    columns={columns}
                    filteredItems={getCurrentPageItems()}
                    navigateToItemPage={navigateToVolumePage}
                    handleDeleteItem={handleDeleteVolume}
                    handleUpdateItemStatus={handleUpdateVolumeStatus}
                />
            </div>
        </>
    );
};